import React, { useState as uState } from 'react';

import { useNavigate as uNavigate } from 'react-router-dom'


import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import './Register.css'
// import Fb from '../../assets/images/fb.png'
// import Twitt from '../../assets/images/twitter.png'
// import Insta from '../../assets/images/instagram.png'

export default function register() {
  const navigate=uNavigate()

  const [user, setUser] = uState({
    name:"",
    mobile:"",
    email:"",
    password:""
  })

  const handleChange = (event) => {
    setUser({
      ...user,
      [event.target.name]:event.target.value
    })
  }

  const handleSubmit = async(e) => {
    // perform form login
    if (user.email === '') {
      alert('user Email is Empty')
    }
    else {

      e.preventDefault()
      const response = await fetch('http://localhost:8000/users/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: user.name,
          mobile: user.mobile,
          email: user.email,
          password: user.password
        })
      })

      const json = await response.json()

      if (!json.success) {
alert('error in sending data')
      }
      else {
        localStorage.setItem('userEmail', user.email)
        localStorage.setItem('authToken', json.authToken)
        navigate('/')
      }

    }

  }

  const handleShowPass = () => {
    const Text=document.getElementById('form3Example4')
    const InnerHtml=document.getElementById('showPass')
    if (Text.type==='password') {
      Text.type = 'text'
      InnerHtml.innerHTML='Hide Password'
    }
    else {
      Text.type = 'password'
      InnerHtml.innerHTML = 'Show Password'
    }


  }
  return (
    <>
      <Navbar/>
      <section className="background-radial-gradient overflow-hidden">

        <div className="container px-4 py-1 px-md-5 text-center text-lg-start my-5">
          <div className="row gx-lg-5 align-items-center mb-5">
            <div className="col-lg-6 mb-5 mb-lg-0 registerText" style={{ zIndex: '10' }}>
              <h1 className="my-5 display-5 fw-bold ls-tight" style={{ 'color': 'hsl(218, 81%, 95%)' }}>
                The best Medicine <br />
                <span style={{ 'color': 'hsl(218, 81%, 75%)' }}>for your Cure</span>
              </h1>
              <p className="mb-4 opacity-70" style={{ 'color': 'hsl(218, 81%, 85%)' }}>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Temporibus, expedita iusto veniam atque, magni tempora mollitia
                dolorum consequatur nulla, neque debitis eos reprehenderit quasi
                ab ipsum nisi dolorem modi. Quos?
              </p>
            </div>

            <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
              <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
              <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

              <div className="card bg-glass">
                <div className="card-body px-4 py-5 px-md-5">
                  <form onSubmit={handleSubmit}>

                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="form-outline">
                          <input required name="name" onChange={handleChange} value={user.name } type="text" id="form3Example1" className="form-control" minLength='5' pattern='[A-Za-z\s]+' />
                          <label className="form-label" htmlFor="form3Example1">Full Name</label>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="form-outline">
                          <input name="mobile" onChange={handleChange} value={user.mobile} type="tel" id="form3Example2" className="form-control" minLength='10' maxLength='10' pattern="[789][0-9]{9}" />
                          <label className="form-label" htmlFor="form3Example2">Mobile Number</label>
                        </div>
                      </div>
                    </div>


                    <div className="form-outline mb-4">
                      <input  name="email" onChange={handleChange} value={user.email} type="email" id="form3Example3" className="form-control" minLength='5'/>
                      <label className="form-label" htmlFor="form3Example3">Email address</label>
                    </div>


                    <div className="form-outline mb-4">
                      <input required name="password" onChange={handleChange} value={user.password} type="password" id="form3Example4" className="form-control" minLength='6' />
                      <label className="form-label" htmlFor="form3Example4">Password</label>
                    </div>
                    <input onClick={handleShowPass} className="form-check-input me-2" type="checkbox" value="" id="form2Example3" />
                    <label id='showPass' className="form-check-label" htmlFor="form2Example3">
                      Show Password
                    </label>
                    <button  type="submit" className="btn btn-primary btn-block mb-4">
                      Sign up
                    </button>                    

                    {/* <div className="text-center">
                      <p>or sign up with:</p>
                      <button onClick={''} className='socialL mx-1'>
                        <img src={Fb} alt="" className="s-1" width='20px' />
                      </button>
                      <a href="#!" className='socialL mx-1'>
                        <img src={Twitt} alt="" className="s-2 " width='20px' />
                      </a>
                      <a href="#!" className='socialL mx-1'>
                        <img src={Insta} alt="" className="s-3" width='20px' />
                      </a>
                    </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>


      </section>
<Footer/>
    </>
  )
}
